import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=7323d9bb&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"
import style0 from "./Popups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports